import { useEffect, useRef } from 'react';
import { useSentry } from './context';
import type { CFTPipeValue, CFTValue } from './sentry-tags';

export function useSentrySetCft({ cft, pipe }: { cft: CFTValue; pipe?: CFTPipeValue }): void {
  const sentry = useSentry();
  const mounted = useRef(false);

  if (!mounted.current) {
    sentry.setTagInCurrentScope('CFT', cft);
    sentry.setTagInCurrentScope('PIPE', pipe);
  }

  useEffect(() => {
    mounted.current = true;

    return () => {
      sentry.setTagInCurrentScope('CFT', 'not-cft');
      sentry.setTagInCurrentScope('PIPE', undefined);
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- only run once
  }, []);
}
